import { fakeApiHelper } from '~~utils/CommonUtils';
import ApiService from '~~commonAPIs/ApiService';

const debugStatus = {
  updatePermission: false,
  getLeagueWithSeasons: false,
};

const League = {
  updatePermission: ({ userUniqid, leagueUniqid, authority }) => {
    if (debugStatus.updatePermission) {
      return fakeApiHelper(200, 'success', {
        data: {
          permission: 'ADMIN',
        },
        error: false,
        message: 'Request successfully',
      });
    }

    return ApiService.put(`/api/users/${userUniqid}/permission/league/${leagueUniqid}`, { data: { authority } });
  },

  getLeagueWithSeasons: ({ leagueUniqid }) => {
    if (debugStatus.getLeagueWithSeasons) {
      return fakeApiHelper(200, 'success', {
        data: {
          cover_path: '',
          cover_url: '',
          description: '',
          index_featureds: [],
          index_stats: {
            total_players: '',
            total_seasons: '',
            total_teams: '',
            total_years: '',
          },
          logo_path: '',
          logo_url: '',
          name: 'OOOO 聯會',
          seasons: [
            {
              auto_game_seq: false,
              description: '',
              end_at: '2021-01-29T00:00:00+08:00',
              league: {
                name: 'OOOO 聯會',
                uniqid: 'wxyz',
              },
              start_at: '2021-01-21T00:00:00+08:00',
              title: '2021 xxxx 冬季聯賽',
              type: 'CUP_MATCHES',
              uniqid: 'wxyz-2021-zxcv',
              year: 2021,
            },
            {
              auto_game_seq: true,
              description: '',
              end_at: '2020-07-23T23:59:59+08:00',
              league: {
                name: 'OOOO 聯會',
                uniqid: 'wxyz',
              },
              start_at: '2020-07-15T00:00:00+08:00',
              title: '2020 xxxx 夏季聯賽',
              type: 'CUP_MATCHES',
              uniqid: 'wxyz-2020-zxcv',
              year: 2020,
            },
          ],
          type: 'SENIOR_HIGH_SCHOOL',
          uniqid: 'wxyz',
        },
        error: false,
        message: 'Get leagues successfully',
      });
    }

    return ApiService.get(`/api/leagues/${leagueUniqid}`);
  },

  updateProfile: ({ leagueUniqid, data }) => {
    return ApiService.put(`/api/leagues/${leagueUniqid}`, { data });
  },
};

export default League;
